import {
  Button,
  CircularProgress,
  TableCell,
  TableRow,
  TextField,
} from '@mui/material';
import { useState } from 'react';
import { NumericFormat } from 'react-number-format';

import useFormSubmit from 'hooks/useFormSubmit';

export default function ProductRow({ row, rowIndex }) {
  const { submit, isSubmitting } = useFormSubmit();
  const [value, setValue] = useState('');
  const allParties = row?.comes?.reduce((a, c) => a + c?.amount, 0);

  const onSubmit = () => {
    const url = `/admin/orders/comes/${row?.id}`;
    submit(
      { type: 'post', contentType: 'simple' },
      { amount: value },
      url,
      'message',
      null,
      true,
      () => {}
    );
  };

  return (
    <TableRow hover tabIndex={-1}>
      <TableCell size='small'>{rowIndex + 1}</TableCell>
      <TableCell size='small'>{row?.product?.name || ''}</TableCell>
      <TableCell size='small'>{row?.amount || ''}</TableCell>
      <TableCell size='small'>{row?.amount - row?.left || '0'}</TableCell>
      <TableCell size='small'>
        <NumericFormat
          value={Number(value) || ''}
          onChange={(e) => {
            const val = parseFloat(e.target.value.replace(/\s/g, ''));
            setValue(val);
          }}
          isAllowed={({ floatValue }) => {
            if (!floatValue) return true;
            return floatValue <= allParties + row?.amount;
          }}
          customInput={TextField}
          allowNegative={false}
          thousandSeparator=' '
          decimalScale={3}
          size='small'
          fullWidth
        />
      </TableCell>
      <TableCell size='small'>
        <Button
          onClick={onSubmit}
          disabled={!value || isSubmitting}
          startIcon={isSubmitting ? <CircularProgress /> : ''}
          variant='contained'
          color='success'
          size='small'
        >
          Tasdiqlash
        </Button>
      </TableCell>
    </TableRow>
  );
}
